import { render, staticRenderFns } from "./offer-restrictions.vue?vue&type=template&id=3da462a0&scoped=true"
import script from "./offer-restrictions.vue?vue&type=script&lang=js"
export * from "./offer-restrictions.vue?vue&type=script&lang=js"
import style0 from "./offer-restrictions.vue?vue&type=style&index=0&id=3da462a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da462a0",
  null
  
)

export default component.exports